import styled from '@emotion/styled'
import {
  completedDirectivesFilter,
  draftDirectivesFilter,
  useUserDirectiveSharedWithList,
  useUserFilteredDirectiveList,
} from 'api/goodtrust/user/directive'
import { DirectiveList } from 'components/directive/directiveList/DirectiveList'
import { TabSpecification } from 'components/tabs/Tabs'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { colors } from 'utils/colors'

export const useEstatePlanningTabs = () => {
  const { t } = useTranslation('estate_planning_lp')
  const completedDirectives = useUserFilteredDirectiveList(completedDirectivesFilter)
  const draftDirectives = useUserFilteredDirectiveList(draftDirectivesFilter)
  const sharedDirectives = useUserDirectiveSharedWithList()

  const completedCount = completedDirectives?.data?.[0]?.json?.items_count_total
  const draftCount = draftDirectives?.data?.[0]?.json?.items_count_total
  const sharedCount = sharedDirectives?.data?.[0]?.json?.items_count_total

  const tabs: TabSpecification[] = [
    {
      key: 'your-estate-plan',
      label: t('estate_planning_lp.inside.tabs.your_estate_plan.label'),
      content: (
        <DirectiveList
          directiveSwr={completedDirectives}
          emptyStateTitle={t('estate_planning_lp.inside.tabs.your_estate_plan.empty_title')}
          emptyStateDescription={t('estate_planning_lp.inside.tabs.your_estate_plan.empty_desc')}
        />
      ),
    },
    {
      key: 'drafts',
      label: (
        <SLabelText>
          {t('estate_planning_lp.inside.tabs.drafts.label')}
          {!!draftCount && <SCountText variant={'label'}>{draftCount}</SCountText>}
        </SLabelText>
      ),
      content: (
        <DirectiveList
          directiveSwr={draftDirectives}
          emptyStateTitle={t('estate_planning_lp.inside.tabs.drafts.empty_title')}
          emptyStateDescription={t('estate_planning_lp.inside.tabs.drafts.empty_desc')}
        />
      ),
    },
    {
      key: 'shared-with-you',
      label: (
        <SLabelText>
          {t('estate_planning_lp.inside.tabs.shared_with_you.label')}
          {!!sharedCount && <SCountText variant={'label'}>{sharedCount}</SCountText>}
        </SLabelText>
      ),
      content: (
        <DirectiveList
          directiveSwr={sharedDirectives}
          emptyStateTitle={t('estate_planning_lp.inside.tabs.shared_with_you.empty_title')}
          emptyStateDescription={t('estate_planning_lp.inside.tabs.shared_with_you.empty_desc')}
        />
      ),
    },
  ]

  const defaultTabKey = !completedCount && draftCount ? 'drafts' : undefined

  return { tabs, defaultTabKey }
}

const SLabelText = styled(Text)`
  display: inline-flex;
  align-items: center;
`

const SCountText = styled(Text)`
  background: ${colors.blue[100]};
  min-width: 1rem;
  height: 1rem;
  display: flex;
  margin-left: 0.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
  color: ${colors.blue[500]};
`
